// src/components/GuestRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function GuestRoute({ children }) {
  const { user, loading } = useAuth();

  // Keep layout stable while auth is loading
  if (loading) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600"></div>
          <p className="mt-2 text-ink/60">Loading...</p>
        </div>
      </div>
    );
  }

  // If already signed in, send to home for role-based routing
  if (user) return <Navigate to="/" replace />;

  return children;
}
